import {
    REFURBISH_DEVICE_OPEN_MODAL,
    REFURBISH_DEVICE_CLOSE_MODAL,
    REFURBISH_DEVICE_REQUEST,
    REFURBISH_DEVICE_RESULT,
} from 'Redux/actionTypes';

export const refurbishDeviceOpenModal = () => ({
    type: REFURBISH_DEVICE_OPEN_MODAL,
})

export const refurbishDeviceCloseModal = () => ({
    type: REFURBISH_DEVICE_CLOSE_MODAL,
})

export const refurbishDeviceRequest = (data) => ({
    type: REFURBISH_DEVICE_REQUEST,
    payload: data
})

export const refurbishDeviceResult = (result) => ({
    type: REFURBISH_DEVICE_RESULT,
    payload: result
})